/**
 * Elilhaam Wishlist — localStorage-based
 * 
 * API (global):
 *   Wishlist.get()                → array of product ids
 *   Wishlist.add(id, data)        → save product {id, title, url, image, price, vendor}
 *   Wishlist.remove(id)           → remove by id
 *   Wishlist.has(id)              → boolean
 *   Wishlist.toggle(id, data)     → add if absent, remove if present → returns boolean (true=added)
 *   Wishlist.count()              → number
 *   Wishlist.getAll()             → array of product data objects
 *   Wishlist.clear()              → empty wishlist
 *
 * Events (dispatched on document):
 *   wishlist:change               → detail: { ids, count }
 *   wishlist:add                  → detail: { id }
 *   wishlist:remove               → detail: { id }
 */

(function (w) {
  var STORAGE_KEY = 'elilhaam_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
    catch (e) { return {}; }
  }

  function write(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); }
    catch (e) {}
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
  }

  function emitChange() {
    var data  = read();
    var ids   = Object.keys(data).map(Number);
    var count = ids.length;
    emit('wishlist:change', { ids: ids, count: count });
    // Update all count badges
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    // Update all heart buttons
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var pid = parseInt(btn.dataset.wishlistBtn, 10);
      var active = ids.indexOf(pid) > -1;
      btn.classList.toggle('wl-btn--active', active);
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Save to wishlist');
    });
  }

  var Wishlist = {
    get: function () {
      return Object.keys(read()).map(Number);
    },
    getAll: function () {
      return Object.values(read());
    },
    has: function (id) {
      return !!(read()[id]);
    },
    count: function () {
      return Object.keys(read()).length;
    },
    add: function (id, data) {
      var store = read();
      store[id] = Object.assign({ id: id }, data || {});
      write(store);
      emit('wishlist:add', { id: id });
      emitChange();
    },
    remove: function (id) {
      var store = read();
      delete store[id];
      write(store);
      emit('wishlist:remove', { id: id });
      emitChange();
    },
    toggle: function (id, data) {
      if (this.has(id)) { this.remove(id); return false; }
      else               { this.add(id, data); return true; }
    },
    clear: function () {
      write({});
      emitChange();
    }
  };

  w.Wishlist = Wishlist;

  // Init badges + buttons on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function () {
    emitChange();
  });

  // Delegated click handler for ALL wishlist buttons across the page
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var pid    = parseInt(btn.dataset.wishlistBtn, 10);
    var title  = btn.dataset.title  || '';
    var url    = btn.dataset.url    || '';
    var image  = btn.dataset.image  || '';
    var price  = btn.dataset.price  || '';
    var vendor = btn.dataset.vendor || '';

    var added = Wishlist.toggle(pid, { id: pid, title: title, url: url, image: image, price: price, vendor: vendor });

    // Brief pulse animation
    btn.classList.add('wl-btn--pulse');
    setTimeout(function () { btn.classList.remove('wl-btn--pulse'); }, 400);

    // Toast notification
    showWishlistToast(added
      ? (title ? '\u2665 ' + title.substring(0, 28) + (title.length > 28 ? '\u2026' : '') + ' saved' : 'Saved to wishlist')
      : 'Removed from wishlist'
    );
  });

  // Toast
  function showWishlistToast(msg) {
    var existing = document.getElementById('wl-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'wl-toast';
    toast.textContent = msg;
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
    setTimeout(function () {
      toast.classList.add('wl-toast--visible');
    }, 10);
    setTimeout(function () {
      toast.classList.remove('wl-toast--visible');
      setTimeout(function () { toast.remove(); }, 300);
    }, 2200);
  }

}(window));
